var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSnow = function SvgSnow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 252 252",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 1L15.2519 8.24732C12.1426 12.5412 12.2536 18.3752 15.5239 22.5477L18.9254 26.8875C21.8053 30.5619 20.5929 35.9536 16.4172 38.0414V38.0414C11.7027 40.3986 10.9078 46.7956 14.902 50.235L16.7227 51.8029C20.8398 55.3482 20.8898 61.709 16.829 65.3187L15.0066 66.9386C10.5287 70.919 10.6409 77.9507 15.2435 81.7862L16.9464 83.2053C20.8422 86.4518 20.7695 92.4587 16.7962 95.6099V95.6099C13.1358 98.513 12.7342 103.923 15.9258 107.334L17.8439 109.385C21.6055 113.406 21.6548 119.64 17.9573 123.72L16.7501 125.052C12.8059 129.404 12.4129 135.911 15.8046 140.707L19.0231 145.257C22.2119 149.765 21.7931 155.894 18.0207 159.926V159.926C13.6026 164.649 13.883 172.068 18.645 176.444L20.5313 178.177C25.2365 182.501 26.4673 189.438 23.5365 195.117L20.5 201",
    id: "Line1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 1L42.8215 6.53434C46.3688 10.2236 45.2924 16.2991 40.6936 18.545L39.6461 19.0565C34.7857 21.4302 34.4242 28.2199 39.0051 31.0962L40.7006 32.1608C44.6603 34.6472 44.2329 40.5483 39.9562 42.438V42.438C35.4213 44.4418 35.2944 50.8306 39.7462 53.0128L41.174 53.7127C46.2161 56.1844 46.0072 63.4452 40.8504 65.6679V65.6679C35.288 68.0655 35.5724 76.076 41.3103 78.0167L44.4754 79.0873C50.556 81.1439 51.7692 89.2129 46.5623 92.9667L44.2062 94.6653C40.3726 97.429 39.191 102.611 41.4477 106.764L43.7892 111.072C47.3506 117.625 45.54 125.8 39.5448 130.237L34.0495 134.303C29.1484 137.93 28.3296 144.943 32.2634 149.601L38.8066 157.35C41.1207 160.09 39.6111 164.308 36.0836 164.958V164.958C31.9916 165.712 30.8524 171.036 34.2777 173.398L43.8174 179.978C48.9515 183.518 49.3238 190.968 44.5683 195.003L37.5 201",
    id: "Line2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5 1L54.6281 15.6158C53.2213 19.836 55.768 24.3478 60.108 25.3243V25.3243C65.5653 26.5522 67.8163 33.0989 64.2681 37.4233L63.8947 37.8784C60.2266 42.3488 62.4643 49.1161 68.0744 50.5186L68.5016 50.6254C74.9612 52.2403 76.8691 60.4964 71.773 64.7818L70.7684 65.6265C66.3373 69.3527 66.6327 76.264 71.3656 79.5985L72.0355 80.0704C77.6479 84.0247 77.3103 92.453 71.3996 95.9457L62.0283 101.483C54.5164 105.922 56.6243 117.318 65.227 118.776L66.9594 119.069C75.8732 120.58 77.0949 132.889 68.652 136.123L65.6388 137.277C60.0308 139.424 59.2924 147.058 64.3849 150.241L67.4723 152.17C71.9609 154.976 70.6977 161.827 65.5038 162.847V162.847C60.4476 163.841 59.0647 170.42 63.2931 173.365L71.609 179.156C76.2311 182.375 77.3419 188.745 74.0821 193.339L69 200.5",
    id: "Line3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5 1L88.896 3.60402C85.2599 7.24011 87.3754 13.4673 92.474 14.1359V14.1359C98.339 14.9051 99.7859 22.7337 94.6731 25.7084V25.7084C90.0718 28.3855 90.5987 35.2632 95.6016 37.0824L98.0858 37.9857C103.563 39.9773 104.787 47.1745 100.276 50.8648L98.6577 52.1892C92.7509 57.022 95.5649 66.5848 103.137 67.5398V67.5398C112.122 68.6731 113.65 81.1221 105.148 84.2431L98.0316 86.8555C90.3798 89.6644 92.3947 101 100.546 101V101C108.475 101 110.712 111.868 103.426 114.999L93.1524 119.414C85.8833 122.538 85.3045 132.621 92.1682 136.556L95.5604 138.501C103.292 142.934 103.303 154.083 95.5786 158.53L94.3876 159.216C87.3858 163.248 86.506 173.005 92.6737 178.224V178.224C96.7007 181.631 97.9386 187.318 95.6925 192.091L91.5 201",
    id: "Line4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M119.5 1L122.46 2.55053C129.968 6.48331 129.844 17.273 122.248 21.0321L117.061 23.5985C109.475 27.3528 111.315 38.658 119.701 39.812L127.763 40.9215C133.568 41.7204 134.912 49.5088 129.709 52.2064V52.2064C125.401 54.4402 125.382 60.5959 129.676 62.856L135.641 65.9955C143.355 70.0552 142.02 81.4839 133.578 83.6563L121.628 86.7319C111.891 89.2376 111.256 102.825 120.717 106.227L127.208 108.562C133.865 110.956 133.972 120.332 127.371 122.878V122.878C121.221 125.25 120.761 133.775 126.62 136.796L131.188 139.152C136.882 142.087 137.543 149.968 132.418 153.811L126.85 157.987C123.701 160.349 124.445 165.266 128.153 166.59V166.59C132.444 168.123 132.548 174.153 128.312 175.833L119.613 179.283C115.173 181.043 113.068 186.127 114.964 190.511L119.5 201",
    id: "Line5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M154.5 1L147.419 16.8475C145.5 21.1417 147.269 26.187 151.448 28.3442V28.3442C155.867 30.6247 157.546 36.092 155.171 40.4601L148.691 52.3751C146.118 57.1051 147.944 63.0253 152.734 65.4849V65.4849C157.901 68.1381 159.54 74.7396 156.216 79.5021L149.86 88.6057C146.976 92.7377 148.983 98.4813 153.813 99.9174V99.9174C158.298 101.251 160.43 106.364 158.22 110.489L152.177 121.77C149.33 127.084 149.863 133.572 153.538 138.35L156.64 142.382C159.915 146.64 159.25 152.723 155.133 156.172L152.609 158.287C148.452 161.77 149.147 168.382 153.879 171.032V171.032C159.658 174.269 158.992 182.89 152.718 185.015V185.015C146.707 187.051 145.649 195.1 150.93 198.62L154.5 201",
    id: "Line6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M167.5 1L171.772 7.02022C175.936 12.8866 176.654 20.528 173.657 27.0673L170.632 33.6673C168.768 37.7339 169.758 42.5396 173.078 45.538L175.698 47.905C179.38 51.2305 178.901 57.1444 174.732 59.834V59.834C170.902 62.305 170.124 67.5834 173.078 71.0545L178.608 77.5516C182.111 81.6683 179.186 88 173.78 88V88C168.208 88 165.346 94.6718 169.187 98.7089L172.068 101.738C175.468 105.313 174.928 111.067 170.922 113.947L170.156 114.497C165.993 117.489 165.187 123.359 168.39 127.362L171.718 131.522C175.71 136.513 175.821 143.573 171.986 148.685L167.311 154.918C162.933 160.757 164.763 169.122 171.18 172.597V172.597C177.471 176.005 179.379 184.14 175.258 189.989L167.5 201",
    id: "Line7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M185.5 1L182.564 23.3857C181.893 28.5015 183.638 33.6384 187.287 37.2868V37.2868C192.219 42.2189 193.543 49.7074 190.602 56.0317L189.142 59.1697C186.804 64.1957 186.493 69.9291 188.272 75.1787L192.464 87.5451C194.376 93.1833 193.525 99.392 190.168 104.308L186.144 110.2C183.437 114.163 183.877 119.48 187.197 122.945V122.945C190.565 126.459 190.963 131.87 188.146 135.839L178.292 149.725C174.486 155.088 176.44 162.586 182.38 165.41L186.855 167.537C192.889 170.406 193.058 178.932 187.142 182.038V182.038C183.831 183.776 182.139 187.554 183.046 191.182L185.5 201",
    id: "Line8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "50%",
    fx: "50%",
    fy: "50%",
    id: "radialGradient-1",
    r: "72.4736449%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    filterUnits: "objectBoundingBox",
    height: "262.5%",
    id: "filter-3",
    width: "262.5%",
    x: "-81.2%",
    y: "-68.8%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    type: "matrix",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.5 0"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 1,
    fill: "url(#radialGradient-1)",
    id: "path-2",
    r: 3
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "12s",
    dur: "17s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#Line5"
  })))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 1,
    fill: "url(#radialGradient-1)",
    id: "path-2",
    r: 2
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "9s",
    dur: "19s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#Line6"
  })))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 1,
    fill: "url(#radialGradient-1)",
    id: "path-2",
    r: 2
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "11s",
    dur: "20s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#Line6"
  })))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 1,
    fill: "url(#radialGradient-1)",
    id: "path-2",
    r: 3
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "3s",
    dur: "13s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#Line6"
  })))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 1,
    fill: "url(#radialGradient-1)",
    id: "path-2",
    r: 2
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "7s",
    dur: "12s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#Line6"
  })))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 1,
    fill: "url(#radialGradient-1)",
    id: "path-2",
    r: 3
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "20s",
    dur: "19s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#Line5"
  })))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 1,
    fill: "url(#radialGradient-1)",
    id: "path-2",
    r: 3
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "21s",
    dur: "21s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#Line2"
  })))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 1,
    fill: "url(#radialGradient-1)",
    id: "path-2",
    r: 2
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "6s",
    dur: "17s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#Line3"
  })))), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 1,
    fill: "url(#radialGradient-1)",
    id: "path-2",
    r: 2
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "2s",
    dur: "22s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#Line5"
  })))), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 1,
    fill: "url(#radialGradient-1)",
    id: "path-2",
    r: 2
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "5s",
    dur: "13s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#Line2"
  })))), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 1,
    fill: "url(#radialGradient-1)",
    id: "path-2",
    r: 3
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "5s",
    dur: "20s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#Line4"
  })))), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 1,
    fill: "url(#radialGradient-1)",
    id: "path-2",
    r: 2
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "4s",
    dur: "22s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#Line7"
  })))), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 1,
    fill: "url(#radialGradient-1)",
    id: "path-2",
    r: 3
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "9s",
    dur: "11s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#Line3"
  })))), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 1,
    fill: "url(#radialGradient-1)",
    id: "path-2",
    r: 2
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "10s",
    dur: "19s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#Line2"
  })))), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 1,
    fill: "url(#radialGradient-1)",
    id: "path-2",
    r: 3
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "9s",
    dur: "20s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#Line5"
  })))), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 1,
    fill: "url(#radialGradient-1)",
    id: "path-2",
    r: 3
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "9s",
    dur: "19s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#Line2"
  })))), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 1,
    fill: "url(#radialGradient-1)",
    id: "path-2",
    r: 2
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "0s",
    dur: "11s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#Line8"
  })))), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 1,
    fill: "url(#radialGradient-1)",
    id: "path-2",
    r: 3
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "8s",
    dur: "12s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#Line3"
  })))), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 1,
    fill: "url(#radialGradient-1)",
    id: "path-2",
    r: 3
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "18s",
    dur: "19s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#Line4"
  })))), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 1,
    fill: "url(#radialGradient-1)",
    id: "path-2",
    r: 3
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "17s",
    dur: "13s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#Line7"
  })))), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 1,
    fill: "url(#radialGradient-1)",
    id: "path-2",
    r: 3
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "9s",
    dur: "17s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#Line7"
  })))), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 1,
    fill: "url(#radialGradient-1)",
    id: "path-2",
    r: 2
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "19s",
    dur: "12s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#Line5"
  })))), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 1,
    fill: "url(#radialGradient-1)",
    id: "path-2",
    r: 3
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "7s",
    dur: "16s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#Line1"
  })))), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 1,
    fill: "url(#radialGradient-1)",
    id: "path-2",
    r: 3
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "20s",
    dur: "17s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#Line7"
  })))), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 1,
    fill: "url(#radialGradient-1)",
    id: "path-2",
    r: 3
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "16s",
    dur: "10s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#Line6"
  })))), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 1,
    fill: "url(#radialGradient-1)",
    id: "path-2",
    r: 3
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "22s",
    dur: "20s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#Line8"
  })))), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 1,
    fill: "url(#radialGradient-1)",
    id: "path-2",
    r: 3
  }, /*#__PURE__*/React.createElement("animateMotion", {
    begin: "12s",
    dur: "10s",
    repeatCount: "indefinite"
  }, /*#__PURE__*/React.createElement("mpath", {
    xlinkHref: "#Line8"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSnow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/snow.5c8d66140656e473cdeb2b8f9ae019e3.svg";
export { ForwardRef as ReactComponent };